"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORECAST_MODEL = exports.ALL_FORECAST_STATION_CODES = exports.CURRENT_OBS_STATION_CODES = exports.SDGE_STATION_NWS_REGION_MAPPING = exports.SDGE_ADDITIONAL_NWS_MAPPING = exports.ADDITIONAL_NWS_REGIONS = exports.SDGE_NWS_POP_ONLY_MAPPING = exports.SDGE_NWS_WEATHER_CONDITION_ONLY_MAPPING = exports.SDGE_NWS_MAPPING = exports.SEVEN_DAYS_STATIONS = exports.LOW_TEMP_STATIONS = exports.SEVEN_DAYS_CPO_CODES = exports.FORECAST_STATIONS = exports.WEATHER_CONDITION_STATION = exports.FORECAST_STATIONS_LIST = void 0;
const SDGX = { code: 'SDGX', name: 'San Diego', area_label: 'Beaches' };
const MM = { code: 'MM', name: 'Mira Mesa', area_label: 'Mesas' };
const MV = { code: 'MV', name: 'Mission Viejo', area_label: 'Inland Orange County' };
const ECJ = { code: 'ECJ', name: 'El Cajon', area_label: 'Inland Valleys' };
const RAM = { code: 'RAM', name: 'Ramona', area_label: 'Foothills' };
const JUL = { code: 'JUL', name: 'Julian', area_label: 'Mountains' };
const BRG = { code: 'BRG', name: 'Borrego', area_label: 'Deserts' };
const MPE = { code: 'MPE', name: 'Camp Elliot', area_label: 'Miramar' };
const CPO = { code: 'CPO', name: 'Campo', area_label: 'Backcountry Winds & POP' };
exports.FORECAST_STATIONS_LIST = {
    BRG,
    MVN: { code: 'MVN', name: 'Mission Valley North', area_label: 'Mesas' },
    ECJ,
    JUL,
    SOB: { code: 'SOB', name: 'Solana Beach', area_label: 'Beaches' },
    RAM,
    MPE,
    CRI: { code: 'CRI', name: 'Cristianitos', area_label: 'Inland Orange County' },
    CPO,
    ANE: { code: 'ANE', name: 'Alpine', area_label: 'additional_station' },
    CBD: { code: 'CBD', name: 'Carlsbad', area_label: 'additional_station' },
    CST: { code: 'CST', name: 'Crest', area_label: 'additional_station' },
    CLN: { code: 'CLN', name: 'Crestline', area_label: 'additional_station' },
    CWD: { code: 'CWD', name: 'Crestwood', area_label: 'additional_station' },
    FBK: { code: 'FBK', name: 'Fallbrook', area_label: 'additional_station' },
    IMP: { code: 'IMP', name: 'Imperial Valley', area_label: 'additional_station' },
    OMB: { code: 'OMB', name: 'Otay Mesa Border', area_label: 'additional_station' },
    RPO: { code: 'RPO', name: 'Round Potrero', area_label: 'additional_station' },
    SCR: { code: 'SCR', name: 'San Clemente Ridge', area_label: 'additional_station' },
    SIL: { code: 'SIL', name: 'Sill Hill', area_label: 'additional_station' },
    MIG: { code: 'MIG', name: 'San Miguel', area_label: 'additional_station' },
};
const additional_stations = [];
for (const key in exports.FORECAST_STATIONS_LIST) {
    if (exports.FORECAST_STATIONS_LIST[key].area_label === 'additional_station')
        additional_stations.push(exports.FORECAST_STATIONS_LIST[key]);
}
const popStation = Object.assign(Object.assign({}, CPO), { area_label: 'POP' });
const windStation = Object.assign(Object.assign({}, CPO), { area_label: 'Backcountry Winds' });
// The weather condition station should be Miramar, but since the mobile app explicitly looks for CPO's expected_weather_conditions, the backend is mapping MPE to CPO
// @TODO: Update mobile app and update this mapping
exports.WEATHER_CONDITION_STATION = Object.assign(Object.assign({}, CPO), { area_label: 'CPO' });
exports.FORECAST_STATIONS = {
    san_diego_region: SDGX,
    mira_mesa_region: MM,
    mission_viejo_region: MV,
    beach_station: exports.FORECAST_STATIONS_LIST.SOB,
    desert_station: exports.FORECAST_STATIONS_LIST.BRG,
    foothills_station: exports.FORECAST_STATIONS_LIST.RAM,
    inland_orange_county_station: exports.FORECAST_STATIONS_LIST.CRI,
    inland_valleys_station: exports.FORECAST_STATIONS_LIST.ECJ,
    mesas_station: exports.FORECAST_STATIONS_LIST.MVN,
    miramar_station: exports.FORECAST_STATIONS_LIST.MPE,
    mountains_station: exports.FORECAST_STATIONS_LIST.JUL,
    // Winds forecast is sourced from Campo
    backcountry_winds_station: windStation,
    pop_station: popStation,
    additional_stations: additional_stations,
};
exports.SEVEN_DAYS_CPO_CODES = [
    exports.FORECAST_STATIONS.san_diego_region.code,
    exports.FORECAST_STATIONS.desert_station.code,
    exports.FORECAST_STATIONS.foothills_station.code,
    exports.FORECAST_STATIONS.mission_viejo_region.code,
    exports.FORECAST_STATIONS.inland_valleys_station.code,
    exports.FORECAST_STATIONS.mira_mesa_region.code,
    exports.FORECAST_STATIONS.miramar_station.code,
    exports.FORECAST_STATIONS.mountains_station.code,
    exports.FORECAST_STATIONS_LIST.CPO.code,
];
exports.LOW_TEMP_STATIONS = { SDGX, MM, MV, ECJ, RAM, JUL, BRG };
exports.SEVEN_DAYS_STATIONS = { SDGX, MM, MPE, MV, ECJ, RAM, JUL, BRG };
exports.SDGE_NWS_MAPPING = {
    RAM: RAM.name,
    MPE: 'Miramar',
    JUL: JUL.name,
    ECJ: ECJ.name,
    BRG: 'Anza-Borrego Desert State Park',
};
// Stations in this mapping only update weather conditions from SFT tabular data. At the moment, no stations are in this category, but this is set up for easy addition of stations in the future if needed.
exports.SDGE_NWS_WEATHER_CONDITION_ONLY_MAPPING = {};
// Stations in this mapping only update POP (probability of precipitation) from SFT tabular data, leaving temperatures and weather conditions untouched.
exports.SDGE_NWS_POP_ONLY_MAPPING = {
    [popStation.code]: popStation.name,
};
exports.ADDITIONAL_NWS_REGIONS = { SDGX, MM, MV };
exports.SDGE_ADDITIONAL_NWS_MAPPING = {
    SOB: SDGX.name,
    MVN: MM.name,
    CRI: MV.name,
};
exports.SDGE_STATION_NWS_REGION_MAPPING = {
    SOB: SDGX,
    MVN: MM,
    CRI: MV,
};
exports.CURRENT_OBS_STATION_CODES = [
    exports.FORECAST_STATIONS.beach_station.code,
    exports.FORECAST_STATIONS.mesas_station.code,
    exports.FORECAST_STATIONS.inland_valleys_station.code,
    exports.FORECAST_STATIONS.foothills_station.code,
    exports.FORECAST_STATIONS.mountains_station.code,
    exports.FORECAST_STATIONS.desert_station.code,
];
const all_codes = [];
for (const key in exports.FORECAST_STATIONS_LIST) {
    all_codes.push(exports.FORECAST_STATIONS_LIST[key].code);
}
exports.ALL_FORECAST_STATION_CODES = all_codes;
var FORECAST_MODEL;
(function (FORECAST_MODEL) {
    FORECAST_MODEL["DEFAULT"] = "displayed";
    FORECAST_MODEL["NBM"] = "nbm";
    FORECAST_MODEL["ECMWF"] = "ecmwf";
    FORECAST_MODEL["NDFD"] = "ndfd";
})(FORECAST_MODEL || (exports.FORECAST_MODEL = FORECAST_MODEL = {}));
